module.exports = __webpack_public_path__ + "img/Group 27158.591fab53.svg";